import DPSEntitySelector from "components/DPSEntitySelector";
import { GlobalContext } from "components/GlobalContext";
import QRCodeReader from "components/QRCodeReader";
import IDealer, { IDealerFilters } from "models/sql/IDealer";
import IFireDepartment, { IFireDepartmentFilters } from "models/sql/IFireDepartment";
import ISalesRep, { ISalesRepFilters } from "models/sql/ISalesRep";
import { useContext, useRef, useState } from "react";
import { Button, Row, Col, Form, Card } from "react-bootstrap";
import DealerService from "services/DealerService";
import FireDepartmentService from "services/FireDepartmentService";
import SalesRepService from "services/SalesRepService";
import EquipmentService from "services/EquipmentService";

const EquipmentMassAdd = () => {
    const globalContext = useContext(GlobalContext);
    const globalContextRef = useRef(globalContext);
    globalContextRef.current = globalContext;
    const [serials, setSerials] = useState<string[]>([]);
    const serialsRef = useRef(serials);
    serialsRef.current = serials;
    const [dealer, setDealer] = useState<IDealer>();
    const [salesRep, setSalesRep] = useState<ISalesRep>();
    const [fireDepartment, setFireDepartment] = useState<IFireDepartment>();
    const [registrationName, setRegistrationName] = useState<string>("");
    const [registrationEmail, setRegistrationEmail] = useState<string>("");

    const onEquipmentScanSuccess = (decodedText: string, decodedResult: any) => {
        console.log("Scan Success", decodedText);
        if (decodedText) {
            const serialPortion = decodedText.split("/").slice(-1)[0].toLowerCase();
            console.log("Serial is " + serialPortion);

            if (serialsRef.current.indexOf(serialPortion) === -1) {
                setSerials([...serialsRef.current, serialPortion]);
            }
        }
    };

    const doRegistrationAsync = async () => {
        if (serials.length > 0) {
            globalContextRef.current.showModal({
                content:
                    <>Are you sure you want to register these {serials.filter(s => !!s)?.length ?? "0"} serial(s)?</>,
                title: `Mass Equipment Registration`,
                okCallback:
                    async (data) => {
                        const serialData = serials.filter(s => !!s).join(",");

                        if (serialData) {
                            globalContextRef.current.setLoading(true);
                            const accessToken = await globalContext.getAccessTokenAsync();
                            const result =
                                await EquipmentService.massCreateAsync(
                                    accessToken,
                                    serialData,
                                    dealer?.dealerId,
                                    salesRep?.salesRepId,
                                    fireDepartment?.fireDepartmentId,
                                    registrationName,
                                    registrationEmail);
                            setSerials([]);
                            globalContextRef.current.setLoading(false);

                            globalContextRef.current.showModal({
                                content:
                                    <>Successfully created {result} out of {(serials.filter(s => !!s)).length}.</>,
                                title: `Mass Equipment Registration`,
                                okCallback:
                                    async (data) => {
                                    },
                                cancelCallback: () => { }
                            });
                        }
                    },
                cancelCallback: () => { }
            });
        }
    };

    return (
        <>
            <Row>
                <Col sm={6}>
                    <h2>Default Values</h2>

                    <DPSEntitySelector<IFireDepartment, IFireDepartmentFilters>
                        entityFilterSearchPropName={"fireDeptNames"}
                        entityService={FireDepartmentService}
                        entityTypeName="Department"
                        defaultEntityFilter={{}}
                        selectedEntityRef={fireDepartment}
                        generateEntityTitle={(entry) => `${entry.fireDeptName} ${entry.hqcity} ${entry.hqstate}, ${entry.hqzip}`}
                        onClickExternalHandler={(entry) => {
                            if (entry) {
                            }
                        }}
                        entityChangeHandler={(newEntry) => {
                            setFireDepartment(newEntry);
                        }}
                    />

                    <DPSEntitySelector<IDealer, IDealerFilters>
                        entityFilterSearchPropName={"dealerNames"}
                        entityService={DealerService}
                        entityTypeName="Dealer"
                        defaultEntityFilter={{}}
                        selectedEntityRef={dealer}
                        generateEntityTitle={(entry) => entry.dealerName ?? ""}
                        onClickExternalHandler={(entry) => {
                            if (entry) {
                            }
                        }}
                        entityChangeHandler={(newEntry) => {
                            setDealer(newEntry);
                        }}
                    />

                    <DPSEntitySelector<ISalesRep, ISalesRepFilters>
                        entityFilterSearchPropName={"names"}
                        entityService={SalesRepService}
                        entityTypeName="Rep"
                        defaultEntityFilter={{ dealerIds: dealer ? [dealer.dealerId] : undefined }}
                        selectedEntityRef={salesRep}
                        generateEntityTitle={(entry) => entry?.fullName ?? ""}
                        onClickExternalHandler={(entry) => {
                            if (entry) {
                            }
                        }}
                        entityChangeHandler={(newEntry) => {
                            setSalesRep(newEntry);
                        }}
                    />

                    <Card className="mb-3 mt-3">
                        <Card.Body>
                            <Card.Title>
                                Providing these will register all equipment as well.
                            </Card.Title>
                            <Form.Control
                                type="text"
                                placeholder="Registration Name"
                                className="mt-2"
                                onChange={
                                    (e: React.ChangeEvent<HTMLInputElement>) => {
                                        setRegistrationName(e.target.value);
                                    }
                                }
                                value={registrationName}
                            />

                            <Form.Control
                                type="text"
                                placeholder="Registration Email"
                                className="mt-3"
                                onChange={
                                    (e: React.ChangeEvent<HTMLInputElement>) => {
                                        setRegistrationEmail(e.target.value);
                                    }
                                }
                                value={registrationEmail}
                            />


                        </Card.Body>
                    </Card>
                    <Form.Control
                        as="textarea"
                        rows={10}
                        className="mt-3"
                        placeholder="Serials"
                        onChange={
                            (e: React.ChangeEvent<HTMLInputElement>) => {
                                // @ts-ignore
                                setSerials((e.target.value ?? "").split("\n"));
                            }
                        }
                        value={(serials ?? []).join("\n")}
                    />
                </Col>
                <Col>
                    <h2>Equipment</h2>
                    <QRCodeReader
                        onScanSuccess={onEquipmentScanSuccess}
                    />

                    <Button
                        variant="success"
                        style={{
                            width: "100%",
                            height: "60px",
                            fontSize: "20px"
                        }}
                        onClick={doRegistrationAsync}>Register {serials.filter(s => !!s)?.length ?? "0"} Serial(s)</Button>
                </Col>
            </Row>
        </>
    );
}

export default EquipmentMassAdd;
